import { App } from './app.class';
import { Fetch } from '../fetch.class';
import { Modal } from './modal.class';
import { Notification } from './notification.class';

class Upgrademodal {

    // Init
    constructor() {

        this.modal = null;
        this.$modal = null;
        this.successCallback = null;

        // Preise fürs Caching abrufen
        setTimeout(() => {
            new Fetch().get(App.getUrl('membership', 'execute_price_caching'))
            .then(response => {})
            .catch(error => {
                console.log("Preise-Cache konnte nicht per XHR geladen werden. "+error.message);
            });
        }, 2000);
    }

    // Modal öffnen
    open(successCallback, feature = '') {

        // Modal noch nicht vorhanden
        if(!this.modal) {
            this.#createModal(() => {
                this.open(successCallback, feature);
            });
            return;
        }

        // Feature selektieren
        const $featuresListLi = this.$modal.querySelectorAll("ul.featureslist > li");
        if($featuresListLi) {
            $featuresListLi.forEach($li => {
                $li.classList.remove("target");
                if(feature != '') {
                    if($li.classList.contains(feature)) {
                        $li.classList.add("target");
                    }
                }
            });
        }

        // Callback übernehmen
        this.successCallback = successCallback;

        // Modal einblenden
        this.modal.show();
    }

    // Modal erstellen
    #createModal(callback) {

        // Markup holen
        new Fetch().get(App.getUrl('membership', 'get_upgrademodal'))
        .then(response => {

            // HTML-Markup einfügen
            const template = document.createElement('template');
            template.innerHTML = response.markup.trim();
            this.$modal = template.content.firstElementChild;
            const $main = document.querySelector('main');
            if($main) {
                $main.insertAdjacentElement('afterend', this.$modal);
            }

            // Handler registrieren

            // Klick auf Upgrade: Tarifwechsel
            const $btnPlanChange = this.$modal.querySelector("button.paddle-change");
            if($btnPlanChange) {
                $btnPlanChange.addEventListener('click', event => {

                    const $ele = event.currentTarget;

                    // Button auf Ladestatus setzen
                    $ele.classList.add('loading');
                    $ele.setAttribute('disabled', true);

                    // Sendedaten
                    const frequencyValue = document.querySelector('input[name="frequency"]:checked').value;
                    const isYearly = frequencyValue=='annually';

                    let productId = 0;
                    if(isYearly === "true")     productId = parseInt( $ele.getAttribute('data-productid-yearly'), 10 );
                    else                        productId = parseInt( $ele.getAttribute('data-productid-monthly'), 10 );

                    const subscription_id = parseInt( $ele.getAttribute('data-subscription-id'), 10 );
                    const account_id = parseInt( $ele.getAttribute('data-account-id'), 10 );

                    // Tarifwechsel per Ajax vornehmen
                    const data = new FormData();
                    data.append('product_id', productId);
                    data.append('subscription_id', subscription_id);
                    data.append('account_id', account_id);

                    new Fetch().post(App.getUrl('membership/change_paid_plan'), data)
                    .then(response => {

                        // Modal schliessen
                        this.modal.close();

                        // Modal mit Markup entfernen
                        setTimeout(() => {
                            this.modal = null;
                            this.$modal.remove();
                            this.$modal = null;
                         }, 300);

                        // Success-Callback ausführen
                        if(this.successCallback) {
                            this.successCallback();
                        }
                    })
                    .catch(error => {
                        new Notification().error(error.message);
                    })
                    .finally(() => {

                        // Button zurücksetzen
                        $ele.classList.remove('loading');
                        $ele.removeAttribute('disabled');
                    });
                });
            }

            // Klick auf Upgrade: Neukunde
            const $btnCheckout = this.$modal.querySelector("button.paddle-checkout");
            if($btnCheckout) {

                // Paddle initialisieren
                Paddle.Setup({ vendor: 120516 });

                $btnCheckout.addEventListener('click', event => {

                    const $ele = event.currentTarget;

                    // Sendedaten
                    const frequencyValue = document.querySelector('input[name="frequency"]:checked').value;
                    const isYearly = frequencyValue=='annually';

                    let productId = 0;
                    if(isYearly) productId = parseInt($ele.getAttribute('data-productid-yearly'), 10 );
                    else         productId = parseInt($ele.getAttribute('data-productid-monthly'), 10 );

                    const account_email = $ele.getAttribute('data-account-email');
                    const account_id = parseInt( $ele.getAttribute('data-account-id') );
                    const locale = $ele.getAttribute('data-locale');
                    const title = $ele.getAttribute('data-title');
                    const plan = $ele.getAttribute('data-plan');

                    const passthrough = {};
                    passthrough.account_id = account_id;
                    passthrough.lang = locale ?? 'en';

                    const para = {
                        product: productId,
                        passthrough: JSON.stringify(passthrough),
                        allowQuantity: false,
                        locale: locale,
                        successCallback: data => {

                            // Modal schliessen
                            this.modal.close();

                            // Modal mit Markup entfernen
                            setTimeout(() => {
                                this.modal = null;
                                this.$modal.remove();
                                this.$modal = null;
                             }, 300);

                            // Success-Callback ausführen
                            if(this.successCallback) {
                                this.successCallback();
                            }
                        },
                    };
                    if(account_email)   para.email = account_email;
                    if(title)           para.title = title;

                    Paddle.Checkout.open(para);
                });
            }

            // Modal init
            this.modal = new Modal(this.$modal);

            // Callback
            callback();
        })
        .catch(error => {
            new Notification().error(error.message);
        });
    }
}

export default new Upgrademodal();